import React from 'react';
import cn from 'classnames';

import { formatMbToGb } from '../../../utils/formatters';
import { formatDateToDay } from '../../../utils/dates';
import DeviceUsageType from '../DeviceUsageType';
import { getPlanAmountFromName } from '../../../utils/plans';
import { getUsageType } from '../../../utils/helpers';

import styles from './styles.module.scss';

const DeviceUsage = ({ subscription }) => {
  const expired = !!subscription?.cancelled_at;
  const hasUsage = subscription?.meta?.usage;
  const total_usage = subscription?.meta?.usage?.total || 0;
  const balance = subscription?.meta?.usage?.balance || 0;
  const used = total_usage - balance;
  const totalUsageInGb = expired
    ? parseInt(getPlanAmountFromName(subscription?.variant_title), 10)
    : formatMbToGb(total_usage);
  const usedInGb = expired
    ? parseInt(getPlanAmountFromName(subscription?.variant_title), 10)
    : formatMbToGb(used);
  const usageInPercent = (used / total_usage) * 100;
  const usageType = getUsageType(subscription?.meta?.usage);
  const renewDate = formatDateToDay(subscription?.meta?.cycle_end_date);
  if (!expired && !hasUsage) {
    return (
      <div className={styles.deviceUsage}>
        <div className={styles.deviceUsageTitle}>Usage</div>
        <p className={styles.deviceUsageNotAvailable}>
          Usage isn't available. Please, check again later.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.deviceUsage}>
      <div className={styles.deviceUsageTitle}>
        Usage
        {!expired && renewDate && (
          <span className={styles.deviceUsageRenew}>
            Data Reset Date: {renewDate}
          </span>
        )}
      </div>
      <div
        className={cn(styles.deviceUsageBar, {
          [styles[usageType?.toLowerCase().replace(' ', '_')]]: !expired,
          [styles.usage_disabled]: expired,
        })}
      >
        <div
          className={cn(styles.deviceUsageBarProgress, {
            [styles[usageType?.toLowerCase().replace(' ', '_')]]: !expired,
            [styles.usage_disabled]: expired,
          })}
          style={{ width: `${usageInPercent}%` }}
        ></div>
      </div>
      <div className={styles.deviceUsageDetails}>
        <div className={styles.deviceUsageDetailsAmount} data-cy="device_usage">
          {usedInGb}
          <em>GB</em>
          <span>/ {totalUsageInGb} GB</span>
        </div>
        {!expired && usageType && (
          <div className={styles.deviceUsageDetailsSeparator}></div>
        )}
        {!expired && <DeviceUsageType usageType={usageType}></DeviceUsageType>}
      </div>
    </div>
  );
};

export default DeviceUsage;
